import React from 'react'

import { useFundUpdates } from './hooks/use-fund-updates'
import { FundUpdatesTemplate } from './template'

const FundUpdates = (): React.JSX.Element => {
  const state = useFundUpdates()

  return <FundUpdatesTemplate state={state} />
}

export default FundUpdates
